import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { ExerciseStatsPage } from 'pages/exercise-stats/exercise-stats';

@NgModule({
    declarations: [ExerciseStatsPage],
    imports: [PagesModule, ComponentsModule],
    exports: [ExerciseStatsPage]
})
export class ExerciseStatsPageModule {}
